// extracted by mini-css-extract-plugin
module.exports = {"intro":"index_intro__4bc1l","projects":"index_projects___C78U"};